import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { IRootState, IModuleAppointmentState } from '../types';

export const state: IModuleAppointmentState = {
    statusSendForm: {
        loading: false,
        status: null
    },
    appointments: [],
    appointmentClicked: 0,
    property: null,
    loading: true
};

const namespaced: boolean = true;

export const appointment: Module<IModuleAppointmentState, IRootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};

export const APPOINTMENT_NAMESPACE = 'appointment';
